var SidePanel    = require("./../SidePanel"),
    $            = require("jquery"),
    itemTemplate = require("./item.ejs");

var LayersTree = SidePanel.extend({

    /**
     *
     * @param options
     */
    initialize: function(options){
        var that = this;

        options || (options = {});

        that._containers = undefined;

        that._layer = undefined;

        LayersTree.__super__.initialize.call(that, options);

        that.getContainer().addClass('layers-tree');
    },

    onAdd: function(view){
        var that = this;

        LayersTree.__super__.onAdd.call(that, view);

        view.getProject().loadContainers({type: 'publish'})
            .then(function(containers){
                var layers;
                that._containers = containers;
                layers = that._containers.filter(function(cont){
                    return Boolean(~$.inArray(cont.get('type'), ['layer', 'virtual', 'material', 'raster']));
                });

                return view.addLayer(layers.pluck('code').join(' '));
            })
            .done(function(layer){

                that._layer = layer;

                that._switchLayers();

                that._buildLevel(0);

                that.getContainer().on('click', '.omjs-cont-item', function(event){
                    that._switchHandler(event, this);
                })
            });
    },

    /**
     *
     * @param parent
     * @private
     */
    _buildLevel: function(parent){
        var that = this,
            items,
            itemCont;

        items = that._containers.filter(function(item){
            return item.get('parent_id') == parent;
        });

        if(!items.getLength()){
            return;
        }

        itemCont = $('<ul></ul>');

        if(parent == 0){
            that.getContainer().append(itemCont);
        }else{
            that.getContainer().find('#omjs_tcont_' + parent).append(itemCont);
        }

        items.each(function(item){
            var itemEl;

            var childs = that._containers.filter(function(it){
                return it.get('parent_id') == item.get('id');
            });

            itemEl = $(itemTemplate({
                'c_code'      : item.get('code'),
                'name'        : item.get('name') || item.get('code'),
                'c_id'        : item.get('id'),
                'map_layer_id': item.get('map_layer_id') || "",
                'active'      : item.get('selected') ? 'active' : "",
                'cont_type'   : item.get('type'),
                'id'          : item.get('map_layer_id')
            }))
                .attr('title', item.get('name') || item.get('code'));

            if(item.get('icon').length){
                itemEl.find('.omjs-cont-icon')
                    .removeClass('layer folder raster virtual')
                    .append('<img src="' + item.get('icon') + '" />')
            }

            itemCont.append(itemEl);

            if(childs.getLength()){
                that._buildLevel(item.get('id'));
            }
        });
    },

    /**
     *
     * @param event
     * @param element
     * @private
     */
    _switchHandler: function(event, element){
        var that     = this,
            $element = $(element),
            container,
            childs;

        $element.toggleClass('active');

        container = that._containers.filter(function(cont){
            return cont.get('code') == $element.data('cont');
        });

        if(!container.getLength()){ return }

        container.at(0).set('selected', $element.hasClass('active'));
        childs = that._containers.filter(function(it){
            return it.get('parent_id') == container.at(0).get('id');
        });

        if(childs.getLength()){
            childs.each(function(child){
                $element.hasClass('active')
                    ? $element.parent().find('.omjs-cont-item').addClass('active')
                    : $element.parent().find('.omjs-cont-item').removeClass('active');

                child.set('selected', $element.hasClass('active'));
            });
        }

        that._switchLayers();

    },

    /**
     *
     * @private
     */
    _switchLayers: function(){
        var that = this,
            activeLayers;

        activeLayers = that._containers.filter(function(cont){
            return cont.get('selected') == true &
                Boolean(~$.inArray(cont.get('type'), ['layer', 'virtual', 'material', 'raster']));
        });

        activeLayers.getLength()
            ? that._layer.show()
            : that._layer.hide();

        that._layer.setActiveLayers(activeLayers.pluck('code'));
    }

});

module.exports = LayersTree;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/LayersTree/LayersTree.js
// module id = 249
// module chunks = 0